export const CLIENT_WEB_EMBEDDER_APP_NAME = 'PWAShell';
export const CLIENT_WEB_TO_EMBEDDER_MESSAGE_POST_METHOD_NAME = 'ReactNativeWebView.postMessage';
export const EMBEDDER_TO_CLIENT_WEB_MESSAGE_POST_METHOD_NAME = '__ReactNativeWebViewMessageHandler__';
export const EMBEDDER_TO_CLIENT_WEB_INITIAL_PROPS_PROP_NAME = '__embeddingInitialProps__' as const;
